import React from 'react';
import { carrierLabel, trackingUrl } from '../../utils/trackingUrl';

export default function OrderTrackingDetails({ order, t }) {
  return (
    <>
      {order.trackingNumber && (
        <div className="mb-5">
          <p className="text-[10px] font-medium text-[#64748b] mb-0.5">
            {t('Tracking Number')}
            {order.carrier ? ` · ${t(carrierLabel(order.carrier))}` : ''}
          </p>
          {trackingUrl(order.carrier, order.trackingNumber) ? (
            <a
              href={trackingUrl(order.carrier, order.trackingNumber)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-semibold text-[#0089ff] underline hover:text-[#0077e6]"
            >
              {order.trackingNumber}
            </a>
          ) : (
            <p className="text-xs font-semibold text-[#0089ff]">{order.trackingNumber}</p>
          )}
        </div>
      )}
    </>
  );
}
